/* eslint-disable */
export default {
  setState: (state, { key, value}) => {
    key && value !== undefined && state.hasOwnProperty(key)
      ? (state[key] = value)
      : null;
  }
};
